import * as React from 'react';
import { Link } from '@cian/ui-kit';

interface IPromoSnippetTitleProps {
  title: string;
  url: string;
  onClick?(e: React.MouseEvent<HTMLElement>): void;
  hovered: boolean;
}

export function PromoSnippetTitle({ title, url, onClick, hovered }: IPromoSnippetTitleProps) {
  return (
    <Link
      data-testid="title"
      href={url}
      target="_blank"
      fontSize="XXL"
      fontWeight="bold"
      onClick={onClick}
      color={hovered ? 'default' : 'current_color'}
    >
      {title}
    </Link>
  );
}
